import { ChevronRightIcon } from '@heroicons/react/24/outline';

// Compact Quick Action Card - horizontal layout friendly
const QuickActionCard = ({ title, description, icon: Icon, variant = 'primary', onClick, badgeCount = 0 }) => {
  const variantStyles = {
    primary: {
      card: 'bg-white dark:bg-gray-800 hover:shadow-lg border-t-2 border-t-primary',
      icon: 'bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-light',
    },
    orange: {
      card: 'bg-white dark:bg-gray-800 hover:shadow-lg border-t-2 border-t-orange-500',
      icon: 'bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400',
    },
    green: {
      card: 'bg-white dark:bg-gray-800 hover:shadow-lg border-t-2 border-t-green-600',
      icon: 'bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400',
    },
    purple: {
      card: 'bg-white dark:bg-gray-800 hover:shadow-lg border-t-2 border-t-purple-600',
      icon: 'bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400',
    },
    red: {
      card: 'bg-white dark:bg-gray-800 hover:shadow-lg border-t-2 border-t-red-500',
      icon: 'bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400',
    },
  };
  const styles = variantStyles[variant] || variantStyles.primary;

  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-2.5 qhd:gap-4 4k:gap-5 p-2.5 qhd:p-4 4k:p-5 rounded-xl qhd:rounded-2xl shadow-md transition-all text-left group ${styles.card}`}
    >
      <div className={`relative w-9 h-9 qhd:w-12 qhd:h-12 4k:w-14 4k:h-14 ${styles.icon} rounded-lg qhd:rounded-xl flex items-center justify-center flex-shrink-0`}>
        <Icon className="w-5 h-5 qhd:w-6 qhd:h-6 4k:w-7 4k:h-7" />
        {badgeCount > 0 && (
          <span className="absolute -top-1.5 -right-1.5 qhd:-top-2 qhd:-right-2 min-w-5 h-5 qhd:min-w-6 qhd:h-6 px-1 flex items-center justify-center bg-red-500 text-white text-[10px] qhd:text-xs font-bold rounded-full shadow-md animate-pulse">
            {badgeCount > 99 ? '99+' : badgeCount}
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-gray-900 dark:text-white font-semibold text-sm qhd:text-base 4k:text-lg">{title}</p>
        <p className="text-gray-500 dark:text-gray-400 text-xs qhd:text-sm 4k:text-base hidden sm:block">{description}</p>
      </div>
      <ChevronRightIcon className="w-4 h-4 qhd:w-5 qhd:h-5 4k:w-6 4k:h-6 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 group-hover:translate-x-0.5 transition-all" />
    </button>
  );
};

export default QuickActionCard;
